import type { BootstrapConfig, SessionUser } from "@gaole/shared";
import { formatPhoneDisplay } from "./phoneInput";

export function isStaffUser(user: SessionUser): boolean {
  return user.isSuperadmin || user.permissions.length > 0;
}

export function needsPhoneVerification(
  user: SessionUser | null | undefined,
  config: BootstrapConfig | null | undefined,
): boolean {
  if (!user || !config?.securityPolicy?.smsOtpEnabled) return false;
  if (isStaffUser(user)) return false;
  return !user.phoneVerifiedAt;
}

export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return "";
  const formatted = formatPhoneDisplay(phone);
  if (formatted.length <= 10) return formatted;
  return formatted.replace(/(\+\d+\s?\d{2})\d+(\d{3})/, "$1 ••• $2");
}
